export class ActivityLogs {
    id?: number;
    patientId: number;
    patientUserId: number;
    fromUserId: number;
    toUserId?: number;
    activityType: string;
    subType?: string;
    activityTime: Date;
    isCompleted: boolean;
    isPatientIntrested?: boolean;
    notes?: string;
    optOutReasonKey?: string;
  
    constructor(data?: Partial<ActivityLogs>) {
      if (data) {
        Object.assign(this, data);
      }
    }
}
  
export enum ActivityTypes{
    CALL= 'Call',
    CHAT= 'Chat',
    SMS = 'SMS',
}

export enum CalActivitySubTypes {
    Counsel = 'Counsel',
    FollowUp = 'FollowUp',
}